export default __webpack_public_path__ + "static/media/token-card-example.d8375485.png";